import {
  getCodePlanFromTupleResponse,
  getNewCodePlanFromTuples
} from '~/components/modals/TaskStatusDetailsModal'
import { AgentTaskStatus } from '~/protos/agents'
import { useTask } from '~/contexts/TaskContext'

export function useCodePlan() {
  const { task: taskObj } = useTask()

  const tuples = taskObj?.details.orderedStateResponses ?? []
  const completedTuple = tuples.findLast(response => {
    return response.taskStatus === AgentTaskStatus.PLANNING_COMPLETED
  })

  if (completedTuple) {
    const index = tuples.findLastIndex(response => {
      return [
        AgentTaskStatus.PLANNING_COMPLETED,
        AgentTaskStatus.PLANNING_UPDATED,
        AgentTaskStatus.PLANNING_REREQUESTED
      ].includes(response.taskStatus)
    })
    const taskStatus = tuples[index].taskStatus

    if (taskStatus !== AgentTaskStatus.PLANNING_COMPLETED) {
      return getNewCodePlanFromTuples(tuples, index)
    }

    return getCodePlanFromTupleResponse(completedTuple)
  }
  return null
}
